export const state = {
  isClose: false,
  isModalClose: null,
  ignoreNextGuard: false,
  isBackToHomeFromOrder: false,
  isBackLastRouter: null,
  isShowActiveTabs: null,
  isShowContentBuyMetfoneEsim: "buyEsim", // used in Home.vue
  isShowContentMobileServices: "home", // used in Home.vue for package bottom nav
  isShowContentTV360: "home", // used by TV360 to toggle between home/history
  tv360PaymentResult: null, // Store TV360 payment result data
};

export const mutations = {
  SET_ACTION_CLOSE(state, newValue) {
    state.isClose = newValue;
  },
  SET_ACTION_MODAL_CLOSE(state, newValue) {
    state.isModalClose = newValue;
  },
  SET_IGNORE_NEXT_GUARD(state, newValue) {
    state.ignoreNextGuard = newValue;
  },
  SET_IS_BACK_TO_HOME_FROM_ORDER(state, newValue) {
    state.isBackToHomeFromOrder = newValue;
  },
  SET_IS_BACK_LAST_ROUTER(state, newValue) {
    state.isBackLastRouter = newValue;
  },
  SET_IS_TABS_SHOW_ACTIVE(state, newValue) {
    state.isShowActiveTabs = newValue;
  },

  SET_IS_SHOW_CONTENT_BUY_METFONE_ESIM(state, newValue) {
    state.isShowContentBuyMetfoneEsim = newValue;
  },
  SET_IS_SHOW_CONTENT_MOBILE_SERVICES(state, newValue) {
    state.isShowContentMobileServices = newValue;
  },
  SET_IS_SHOW_CONTENT_TV360(state, newValue) {
    state.isShowContentTV360 = newValue;
  },
  SET_TV360_PAYMENT_RESULT(state, newValue) {
    state.tv360PaymentResult = newValue;
  },
};

export const actions = {
  async setActionClose({ commit }, value) {
    commit("SET_ACTION_CLOSE", value);
  },
  async setActionModalClose({ commit }, value) {
    commit("SET_ACTION_MODAL_CLOSE", value);
  },
  async setIgnoreNextGuard({ commit }, value) {
    console.log("SET_IGNORE_NEXT_GUARD", value);
    commit("SET_IGNORE_NEXT_GUARD", value);
  },

  async setIsBackToHomeFromOrder({ commit }, value) {
    commit("SET_IS_BACK_TO_HOME_FROM_ORDER", value);
  },

  async setIsBackLastRouter({ commit }, value) {
    commit("SET_IS_BACK_LAST_ROUTER", value);
  },

  async setIsShowActiveTabs({ commit }, value) {
    commit("SET_IS_TABS_SHOW_ACTIVE", value);
  },

  async setIsShowContentBuyMetfoneEsim({ commit }, value) {
    commit("SET_IS_SHOW_CONTENT_BUY_METFONE_ESIM", value);
  },

  async setIsShowContentMobileServices({ commit }, value) {
    commit("SET_IS_SHOW_CONTENT_MOBILE_SERVICES", value);
  },

  async setIsShowContentTV360({ commit }, value) {
    commit("SET_IS_SHOW_CONTENT_TV360", value);
  },

  async setTv360PaymentResult({ commit }, value) {
    commit("SET_TV360_PAYMENT_RESULT", value);
  },
};
